import _ from 'lodash';
import { connect } from 'react-redux';
import { search, searchLogs, advancedSearch } from '../../modules/accounting/rackTransfer';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = (state, ownProps) => {
	/** @namespace state.lists.rackTransferIds **/
	/** @namespace state.maps.rackTransfer **/
	/** @namespace state.maps.user **/
	let pendingRackTransfers = undefined;
	let invalidRackTransfers = undefined;
	let completeRackTransfers = undefined;
	if (state.rackTransfers.byStatus) {
		const { pending, invalid, complete } = state.rackTransfers.byStatus;
		if (pending) {
			pendingRackTransfers = _.map(pending, (id) => state.maps.rackTransfer[id]);
		}
		if (invalid) {
			invalidRackTransfers = _.map(invalid, (id) => state.maps.rackTransfer[id]);
		}
		if (complete) {
			completeRackTransfers = _.map(complete, (id) => state.maps.rackTransfer[id]);
		}
	}

	let rackTransfer;
	let rackTransferId;

	if (ownProps.rackTransfer) {
		rackTransfer = ownProps.rackTransfer;
		rackTransferId = rackTransfer.rackTransferId;
	} else {
		rackTransferId = ownProps.rackTransferId
			? ownProps.rackTransferId
			: _.get(ownProps, ['match', 'params', 'rackTransferId']);
		rackTransfer = _.get(state.maps, ['rackTransfer', rackTransferId]);
	}

	let rackTransferLogs = [];
	/** @namespace state.lists.rackTransferLogIds **/
	/** @namespace state.lists.rackTransferLog **/

	if (state.lists.rackTransferLogIds && state.lists.rackTransferLogIds[rackTransferId]) {
		rackTransferLogs = _.map(
			state.lists.rackTransferLogIds[rackTransferId],
			(id) => state.maps.rackTransferLog[id]
		);
	}

	const canMakeUpdates = !!_.get(state.auth.authUser, ['permissions', 'canMakeUpdates'], false);
	return {
		rackTransfer,
		rackTransferLogs,
		pendingRackTransfers,
		invalidRackTransfers,
		completeRackTransfers,

		userMap: state.maps.user,
		bulkCustomerMap: state.maps.bulkCustomer,
		supplierMap: state.maps.supplier,
		terminalMap: state.maps.terminal,
		carrierMap: state.maps.carrier,
		resourceMap: state.maps.resource,
		invoiceDocumentMap: state.maps.invoiceDocument,
		bulkDeliveryMap: state.maps.bulkDelivery,
		canMakeUpdates,
	};
};
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			advancedSearchRackTransfers: advancedSearch,
			searchRackTransfers: search,
			searchRackTransferLogs: searchLogs,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
